document.addEventListener("DOMContentLoaded", function() {
  //Initial callback
  window.swymCallbackFnSFL = function (swat){
    let productsInCart = document.querySelectorAll(".save-for-later__wrap");
 
    if(swat) {
      swat.fetchLists({
        callbackFn: function(lists) {
          //If user has no wishlists, display all products as available to Save for Later
          if(lists.length == 0) {
            productsInCart.forEach(product => {
              product.addEventListener("click", function(event){
                saveForLaterClick(event);
              });
              product.classList.remove("save-for-later--hidden");
            });
          }
          //If user has wishlists, loop through them
          else {
            lists.forEach(list => {         
              //If there is a list named Save for Later, compare the products in there to the cart products
              if(list.lname.toLowerCase() == "save for later") {
                if(list.listcontents.length > 0) {
                  list.listcontents.forEach(item => {
                    productsInCart.forEach(product => {
                      //If there is a match, mark the product as skippable
                      if(item.epi == product.dataset.variantId) {
                        product.classList.add("skip--product");
                      }
                    });
                  });
                }
                //If there is a Save for Later but it's empty, mark all products as available to save
                else {
                  productsInCart.forEach(product => {
                    product.addEventListener("click", function(event){
                      saveForLaterClick(event);
                    });
                  });
                }
              }
              //If there are wishlists but none are Save for Later, mark all products as available to save
              else {
                productsInCart.forEach(product => {
                  product.addEventListener("click", function(event){
                    saveForLaterClick(event);
                  });
                });
              }
            });

            //Unhide any Save for Later buttons for products that are not currently already saved.
            productsInCart.forEach(product => {
              if(!product.classList.contains("skip--product")) {
                product.classList.remove("save-for-later--hidden");

                product.addEventListener("click", function(event){
                  saveForLaterClick(event);
                });
              }
            });
          }
        },
        errorFn: function(xhrObj) {
          console.error("Swym error - lists could not be fetched. ", xhrObj);
        }
      });
    }
  }

  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFnSFL);


  //User clicks Save for Later
  const saveForLaterClick = function(event) {
    event.preventDefault();

    let target = event.target; 
    let targetParent = target.parentNode;

    let variantId = targetParent.dataset.variantId;
    let variantUrl = targetParent.dataset.variantUrl;
    let parentId = targetParent.dataset.variantParentId;
    let parentTitle = targetParent.dataset.variantParentTitle;
    let variantImage = targetParent.parentNode.parentNode.querySelector(".cart-item__image").src;
    let variantPrice = targetParent.dataset.variantPrice;
    let variantTitle = targetParent.parentNode.querySelector("dd").innerHTML;

    window._swat.fetchLists({
      callbackFn: function(lists) {
        //Build API list objects to pass through in function
        let newSaveForLater = {
          "lname": "Save For Later",
        };

        let productInfoObject = {
          "epi": variantId,
          "du": variantUrl,
          "empi": parentId,
          "iu": variantImage,
          "pr": variantPrice,
          "dt": parentTitle,
          "vi": variantTitle
        };

        //If user has no lists, create SFL and add product
        if(lists.length == 0) {
          createListAndAddProd(newSaveForLater, productInfoObject);
        }
        //If the user does have wishlist(s)
        else {
          let breakLoop = false;
          
          lists.forEach(list => {
            if(list.lname.toLowerCase() == "save for later") {
              breakLoop = true;
              addProdToExistingSFL(list.lid, productInfoObject);
            }
          });

          //Save for later list doesn't exist. Create it, and then add the selected product
          if(breakLoop == false) {
            createListAndAddProd(newSaveForLater, productInfoObject);
          }
        }
      },
      errorFn: function(xhrObj) {
        console.error("Swym error - lists could not be fetched. ", xhrObj);
      }
    });
  }
});

function checkGWP() {
  // Use the single source of truth for faux GWPs on cart.
  window.BrightonGwpFaux?.sync?.();
}

//Create a Save for Later, and add product
const createListAndAddProd = function(newSaveForLater, productInfoObject) {
  window._swat.createList(newSaveForLater, function(sfl){
    window._swat.addToList(sfl.lid, productInfoObject, function(event){
      //Update Shopify Cart object subtotal 
      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { 
          quantity: 0,
          id: event.epi
        },
        dataType: 'json',
        success: function (data) {
          //Subtotal HTML update
          let subtotal = document.querySelector(".totals__subtotal-value");
          subtotal.innerHTML = "$"+ (data.items_subtotal_price/100).toFixed(2);

          //Success message "animation"
          let productToRemoveFromCart = document.querySelector("[data-wrapper-variant-id='"+ event.epi +"']");
          let successMessage = productToRemoveFromCart.querySelector(".save-for-later__wrap");
          successMessage.classList.add("saved");
          successMessage.querySelector(".save-for-later__text").innerHTML = "Saved";
          successMessage.querySelector(".save-for-later__saved").classList.remove("save-for-later--hidden");

          //Check how many items are in cart now, after we removed one
          let currentItemsInCart = 0;
          jQuery.getJSON('/cart.js', function(cart) {
            currentItemsInCart = cart.item_count;
            gwpCount = 0
            cart.items.forEach(function (arrayItem) {
              if(arrayItem.properties['_gwp_gift'] == 1 || arrayItem.properties['_gwp_gift2'] == 1|| arrayItem.properties['_gwp_gift3'] == 1){
                gwpCount = gwpCount + 1
              } 
            }); 
          });

          //Give user a chance to see success message before removing product visually from the cart
          setTimeout(() => {
            productToRemoveFromCart.remove();

            //If cart is now empty, show Your Cart Is Empty default message
            //And hide other cart elements not needed
            if(currentItemsInCart == 0) {
              let cartWarnings = document.querySelector(".cart__warnings");
              let cartWarningTitle = document.querySelector(".cart__empty-text");
              let cartFooter = document.querySelector(".cart__footer-wrapper");
              let cartContents = document.querySelector(".cart__contents");
              let cartTitle = document.querySelector(".title-wrapper-with-link");
              let cartThreshold = document.querySelector(".cart__threshold-messages");

              cartWarnings.style.display = "block";
              cartWarningTitle.style.display = "block";

              cartFooter.style.display = "none";
              cartContents.style.display = "none";
              cartTitle.style.display = "none";
              cartThreshold.style.display = "none";
            }

            if (currentItemsInCart == gwpCount) {
              window.location.href = '/cart/clear'
            } else {
              checkGWP()
            } 
            
          }, 2500);
        }
      });
    }, function(xhrObj) {
      console.error("Swym error - item not added to wishlist.", xhrObj);
    });
  }, function(xhrObj) {
    console.error("Swym error - SFL could not be created. ", xhrObj);
  });
}

//Add product to an existing Save for Later list
const addProdToExistingSFL = function(lid, productInfoObject) {
  window._swat.addToList(lid, productInfoObject, function(event){
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: 0,
        id: event.epi
      },
      dataType: 'json',
      success: function (data) {
        let subtotal = document.querySelector(".totals__subtotal-value");
        subtotal.innerHTML = "$"+ (data.items_subtotal_price/100).toFixed(2);

        let productToRemoveFromCart = document.querySelector("[data-wrapper-variant-id='"+ event.epi +"']");
        let successMessage = productToRemoveFromCart.querySelector(".save-for-later__wrap");
        successMessage.classList.add("saved");
        successMessage.querySelector(".save-for-later__text").innerHTML = "Saved";
        successMessage.querySelector(".save-for-later__saved").classList.remove("save-for-later--hidden");

        let currentItemsInCart = 0;
        jQuery.getJSON('/cart.js', function(cart) {
          currentItemsInCart = cart.item_count;
          gwpCount = 0
          cart.items.forEach(function (arrayItem) {
            if(arrayItem.properties['_gwp_gift'] == 1 || arrayItem.properties['_gwp_gift2'] == 1|| arrayItem.properties['_gwp_gift3'] == 1){
              gwpCount = gwpCount + 1
            } 
          }); 
        });

        setTimeout(() => {
          productToRemoveFromCart.remove();

          if(currentItemsInCart == 0) {
            let cartWarnings = document.querySelector(".cart__warnings");
            let cartWarningTitle = document.querySelector(".cart__empty-text");
            let cartFooter = document.querySelector(".cart__footer-wrapper");
            let cartContents = document.querySelector(".cart__contents");
            let cartTitle = document.querySelector(".title-wrapper-with-link");
            let cartThreshold = document.querySelector(".cart__threshold-messages");

            cartWarnings.style.display = "block";
            cartWarningTitle.style.display = "block";

            cartFooter.style.display = "none";
            cartContents.style.display = "none";
            cartTitle.style.display = "none";
            cartThreshold.style.display = "none";
          }
         
          if (currentItemsInCart == gwpCount) {
            window.location.href = '/cart/clear'
          } else {
            checkGWP()
          }        
        }, 2500);
      }
    });
  }, function(xhrObj) {
    console.error("Swym error - item not added to wishlist.", xhrObj);
  })
}